import { render, staticRenderFns } from "./ClientTools.vue?vue&type=template&id=04898898&scoped=true&"
import script from "./ClientTools.vue?vue&type=script&lang=ts&"
export * from "./ClientTools.vue?vue&type=script&lang=ts&"
import style0 from "./ClientTools.vue?vue&type=style&index=0&id=04898898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04898898",
  null
  
)

export default component.exports